import { NgModule } from '@angular/core';
import { INamedRoute } from 'ngx-named-routes';
import { ExtraOptions, RouterModule } from '@angular/router';
import { WikiComponent } from './wiki.component';

type PathMatch = 'full' | 'prefix' | undefined;

const routes: Array<INamedRoute> = [
    {
        path: '',
        component: WikiComponent,
        children: [
            {
                path: '',
                redirectTo: 'about-us',
                pathMatch: 'full' as PathMatch
            },
            {
                path: 'about-us',
                loadChildren: () => import('./press/press.module').then((m) => m.PressModule)
            },
            {
                path: 'terms',
                loadChildren: () => import('./terms-and-conditions/terms-and-conditions.module').then((m) => m.TermsAndConditionsModule)
            },
            {
                path: 'privacy-policy',
                loadChildren: () => import('./privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyModule)
            },
            {
                path: 'warranty',
                loadChildren: () => import('./warranty/warranty.module').then((m) => m.WarrantyModule)
            },
            {
                path: 'deals',
                loadChildren: () => import('./deals/deals.module').then((m) => m.DealsModule)
            },
            {
                path: 'base-y-condiciones-sorteo',
                loadChildren: () => import('./raffle/raffle.module').then((m) => m.RaffleModule)
            },
            {
                path: 'referral-program',
                loadChildren: () =>
                    import('./referral-transactions-wiki/referral-transactions-wiki.module').then((m) => m.ReferralTransactionsWikiModule)
            }
        ]
    }
];

export const routingConfiguration: ExtraOptions = {
    paramsInheritanceStrategy: 'always'
};

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class WikiRoutingModule {}
